@if (visible()) {
  <div class="fixed inset-x-0 bottom-4 z-50 flex justify-center px-4">
    <div
      class="connection-lost-bubble rounded-radius-container bg-background-fixed drop-shadow-foreground-primary-100-shadow-30 dark:drop-shadow-foreground-secondary-100-shadow-30"
    >
      <div class="flex items-center gap-4 p-4 rounded-radius-container bg-status-error-30 text-xs text-left">
        <svg-icon key="faulted-16" size="32" class="shrink-0 text-status-error-text" />
        <div>{{ 'shared.connection-lost-overlay.message' | translate }}</div>
        <app-button type="error" (clickEvent)="onRefreshClick()">
          {{ 'shared.connection-lost-overlay.refresh' | translate }}
        </app-button>
        <button type="button" class="shrink-0 flex justify-center items-center" (click)="onCloseClick()">
          <svg-icon key="close-16" size="20"></svg-icon>
        </button>
      </div>
    </div>
  </div>
}
